import React from 'react';
import './PageStack.css';

/**
 * Baustein 9 — PageStack.
 * Vertikales Stacking mehrerer Content-Sections mit großem Gap (--space-xl).
 * Für Pages, die mehrere abgegrenzte Bereiche haben (z.B. Decks-Übersicht
 * mit „Virtuelle Decks" + „Physische Decks").
 *
 * Verwendung (innerhalb einer Page):
 *   <PageStack>
 *     <section>
 *       <SectionHeader>Virtuelle Decks</SectionHeader>
 *       ...
 *     </section>
 *     <section>
 *       <SectionHeader>Physische Decks</SectionHeader>
 *       ...
 *     </section>
 *   </PageStack>
 */
export default function PageStack({ children }) {
  return <div className="page-stack">{children}</div>;
}
